import React, { useState } from "react";
import QuestionsAndAnswers from "../../components/Classroom/QuestionsAndAnswers/QuestionsAndAnswers";
import { useLocation, useNavigate } from "react-router-dom";
import { TopBar } from "../../components/CommonComponent/Topbar";

const QuestionsAndAnswersScreen = () => {
  // Getting necessary values from sibling screens
  /* eslint eqeqeq: 0 */
  const { state } = useLocation();
  const { name, currentDataId, currentSourceId, questions, answers } = state;

  const [questionId, setQuestionId] = useState(1);

  const [dataObjects, setDataObjects] = useState([]);
  const dataId = currentDataId;
  const [rerender, setRerender] = useState(false);
  const sourceId = currentSourceId;
  const [open, setOpen] = useState(false);

  var navigate = useNavigate();
  const getData = async () => {
    if (currentSourceId) {
      return fetch(
        `${process.env.REACT_APP_API_ROOT}/api/data/addQAmanually/?SourceId=${currentSourceId}`,
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      ).then((data) => data.json());
    } else {
      return fetch(
        `${process.env.REACT_APP_API_ROOT}/api/data/addQAmanually/?DataId=${currentDataId}`,
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      ).then((data) => data.json());
    }
  };
  React.useEffect(() => {
    let mounted = true;
    getData().then((items) => {
      console.log("Items: ", items);
      if (
        typeof items.message.constructor == "string" ||
        items.message == "No Chat found."
      ) {
      
      } else {
        setDataObjects(items.message);
      }
    });
    return () => (mounted = false);
  }, [open, rerender]);

  // Create function for redirection
  const AddNewQA = () => {
    navigate("/classroom/addNewQuestion", {
      state: {
        sourceId: sourceId,
        dataId: dataId,
        name: name,
      },
    });
  };
  return (
    <>
      <div className="w-full">
        <TopBar backArrow={true} text={"File Content"} />
        <div className="px-8 py-4">
          

        <QuestionsAndAnswers
          open={open}
          setOpen={setOpen}
          setQuestionId={setQuestionId}
          questionId={questionId}
          questions={questions}
          answers={answers}
          dataObjects={dataObjects}
          Id={sourceId ? sourceId : dataId}
          dataId={dataId}
          IdName={sourceId ? "SourceId" : "DataId"}
          rerender={rerender}
          setRerender={setRerender}
        />
        </div>
      </div>
    </>
  );
};

export default QuestionsAndAnswersScreen;
